import React from "react";

const Aboutus = () => {

  return (
    <>
      <div className="dr-header">
        <div className="header-contant">
          <h1> About Us</h1>
          <p>Doctor {" > "} About Us </p>
        </div>
      </div>

      <div className="welcome">
        <h3>About Root AND Tooth Dental Clinic</h3>
        <div className="wel-row">
          <div className="wel-col ">
            <img
              src="/Rahulraj.jpeg"
              alt="image1"
            />
          </div>
          <div className="wel-col">
            <p
              className="childpara2"></p>
            <br />
            Root AND Tooth Dental Clinic is dedicated to providing top-quality dental care in a comfortable and welcoming environment. Our experienced team of dentists and specialists offers a wide range of services, including routine check-ups, cosmetic dentistry, orthodontics, and advanced treatments.
            <br />

            Using the latest technology and modern techniques, we ensure painless procedures and long-lasting results. Whether you need a simple cleaning or a complete smile makeover, we are committed to delivering personalized care to enhance your oral health. Visit Root Tooth Dental Clinic today and experience a brighter, healthier smile!
            <br />
            <br />

            <b>Dr. Rahul Ghanghoriya</b> <br />
            <b>Registration No:</b> A-10812
            <br />
            <p>
              <b>Qualifications:</b> Bachelor of Dental Surgery and Post Graduation Diploma
              in Facial Aesthetics and Clinical Cosmetology
            </p>
          </div>

        </div>
      </div>

      <div className="doctor-about ">


        <p style={{ fontSize: "20px", lineHeight: "2" }}>

          • <b>Comprehensive Dental Care </b>– Offering a full range of services, including general dentistry, cosmetic procedures,  &nbsp;&nbsp;&nbsp;orthodontics, and advanced treatments.

          <br />

          • <b>Experienced Team </b>– Skilled dentists and specialists dedicated to providing high-quality, patient-centered care.

          <br />

          • <b>Advanced Technology </b>– Utilizing modern equipment and the latest techniques for precise, painless, and effective &nbsp;&nbsp;treatments.

          <br />

          • <b>Personalized Treatment Plans </b>– Tailored dental solutions to meet individual patient needs for optimal oral health.

          <br />

          • <b>Comfortable & Hygienic Environment </b>– A clean, friendly, and stress-free clinic ensuring a pleasant experience for &nbsp;&nbsp;every patient.

        </p>
      </div>
    </>
  );
};

export default Aboutus;
